export default __webpack_public_path__ + "static/media/ring.02cd2bc3.mp3";